import { CircleAlert } from "lucide-react";
import { cn } from "../../lib/utils";
import { LoaderCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function OAInput({
    placeholder = "",
    name,
    type = "text",
    mask = "",
    error=null,
    className,
    loading=false,
    value,
    disabled=false,
    onChange,
    ...props
  }) {

    const {t} = useTranslation()
    return (
      <fieldset className="relative animate-fade-in-down flex-1 flex flex-col gap-1">
        <input
          className={cn(`w-full h-10 px-2 py-3 border bg-white border-oaInputBorderColor rounded-[8px] ${error ? 'border-2 border-oaRed':''}`, className)}
          name={name}
          type={type}
          //defaultValue={value}
          placeholder={`${placeholder}`}
          disabled={disabled || loading}
          value={value}
          onChange={onChange}
          {...props}
        />
        {loading && <div className="absolute right-1 top-2 ">
          <LoaderCircle className="animate-spin text-oaBackgroundText"/>
        </div>}
       <div className="flex gap-1 justify-start items-start text-oaRed">
          {error && <>
            <CircleAlert className="size-4 "/>
            <p className="text-xs flex-1">{t(error)}</p>
          </>}
        </div>  
      </fieldset>
    );
  }